module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wrap"
  }, [_c('router-link', {
    staticClass: "header-icon header-logo",
    attrs: {
      "to": {
        name: 'intro',
        params: {
          filter: 'intro'
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/icons/logo.svg"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "header-nav-toggle header-nav-button",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("MENU")]), _vm._v(" "), _c('nav', {
    staticClass: "header-nav",
    class: {
      open: _vm.menu
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'the-magic',
        params: {
          filter: 'the-magic'
        }
      }
    }
  }, [_vm._v("The Magic")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'master-pieces',
        params: {
          filter: 'master-pieces'
        }
      }
    }
  }, [_vm._v("Master Pieces")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'dioramas',
        params: {
          filter: 'dioramas'
        }
      }
    }
  }, [_vm._v("Dioramas")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'manufacturers',
        params: {
          filter: 'manufacturers'
        }
      }
    }
  }, [_vm._v("Manufacturers")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'materials',
        params: {
          filter: 'materials'
        }
      }
    }
  }, [_vm._v("Materials")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'boxes-and-scales',
        params: {
          filter: 'boxes-and-scales'
        }
      }
    }
  }, [_vm._v("Boxes and Scales")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-nav-button",
    attrs: {
      "to": {
        name: 'model-history',
        params: {
          filter: 'model-history'
        }
      }
    }
  }, [_vm._v("E-Type History")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "header-icon header-search",
    attrs: {
      "to": {
        name: 'search'
      }
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/imgs/icons/search.svg"
    }
  })])], 1)]), _vm._v(" "), _c('main', [(_vm.preloading) ? _c('span', [_vm._v("preload")]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-wrap"
  }, [_c('a', {
    staticClass: "footer-insta",
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/etypecorner/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/imgs/icons/instagram.svg")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "footer-credits"
  }, [_vm._v("© 2017 all rights reserved to E-Type Corner")]), _vm._v(" "), _c('a', {
    staticClass: "footer-contact",
    attrs: {
      "href": "mailto:etypecorner@gmail.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/imgs/icons/envelope.svg")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 65
// module chunks = 1